import { render, staticRenderFns } from "./block-ui.vue?vue&type=template&id=591f6a0f&scoped=true&"
import script from "./block-ui.vue?vue&type=script&lang=js&"
export * from "./block-ui.vue?vue&type=script&lang=js&"
import style0 from "./block-ui.vue?vue&type=style&index=0&id=591f6a0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591f6a0f",
  null
  
)

export default component.exports